<template>
    <div >
        <h1 class="title">{{title}}</h1><br>
        <p class="content">{{ content }}</p>
        <p class="date">发布时间：{{ date }}</p>
        <p class="date">发布者：{{ author }}</p>
    </div>
</template>

<script>
export default {
    name:"NoticePage",
    data(){
        return{
            noticeDetail:[],
        }
        
        
    },
    computed:{
        //接收标题、内容、时间参数
        title(){
            return this.$route.query.title
        },
        content(){
            return this.$route.query.content
        },
        date(){
            return this.$route.query.date
        },
        author(){
            return this.$route.query.author
        }
    }
}
</script>

<style>
    .title{
        text-align: center;
    }
    .content{
        padding: 20px;
        line-height: 1.6;
        text-indent: 2em;
    }
    .date{
        text-align: right;
        padding-right:20px ;
    }
</style>